import { LoadingButton } from '@mui/lab';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, InputLabel, ListItemText, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { LLMConfigurationDataType } from '../../types';
import chatGptIcon from "../../assets/chat-gpt.svg";
import geminiIcon from "../../assets/gemini.svg";
import claudeIcon from "../../assets/claude.svg";
import CloseIcon from '@mui/icons-material/Close';
import { createLLMConfiguration } from '../../apis/llm-configurations';


type Props = {
    currentLLMConfigurationData?: LLMConfigurationDataType
    open: boolean;
    handleCloseCreateModal: () => void;
    fetchLLMConfigurations: () => void;
    view: boolean
}

const CreateEdit = ({ view, open, handleCloseCreateModal, currentLLMConfigurationData, fetchLLMConfigurations }: Props) => {
    const [loader, setLoader] = useState(false);
    const [llmConfigurationData, setLLMConfigurationData] = useState<Partial<LLMConfigurationDataType> | undefined>({
        id: 0,
        llm_name: "" as keyof typeof LLMModels,
        llm_model_name: "",
        thread_length: "",
        api_key: "",
    });

    const [validateError, setValidateError] = useState<string[]>([]);
    useEffect(() => {
        setLLMConfigurationData({
            id: currentLLMConfigurationData?.id || 0,
            llm_name: (currentLLMConfigurationData?.llm_name || "") as keyof typeof LLMModels,
            llm_model_name: currentLLMConfigurationData?.llm_model_name || "",
            thread_length: currentLLMConfigurationData?.thread_length || "",
            api_key: currentLLMConfigurationData?.api_key || "",
        });
    }, [currentLLMConfigurationData]);

    const saveTopic = async (e: React.FormEvent<HTMLFormElement>) => {
        let errors: string[] = [];
        e.preventDefault();
        if (!llmConfigurationData?.llm_name?.trim())
            errors = [...errors, "llm_name"];
        if (!llmConfigurationData?.llm_model_name?.trim())
            errors = [...errors, "llm_model_name"];
        if (!llmConfigurationData?.api_key?.trim())
            errors = [...errors, "api_key"];
        if (!llmConfigurationData?.thread_length?.trim())
            errors = [...errors, "thread_length"];
        setValidateError(errors);
        if (errors?.length > 0)
            return;

        const request = {
            id: llmConfigurationData?.id || 0,
            llm_name: llmConfigurationData?.llm_name,
            llm_model_name: llmConfigurationData?.llm_model_name || "",
            thread_length: llmConfigurationData?.thread_length || "",
            api_key: llmConfigurationData?.api_key || "",
        }
        setLoader(true);
        let response = false;
        response = await createLLMConfiguration(request);
        if (response) {
            fetchLLMConfigurations();
            handleCloseCreateModal();
        }
        setLoader(false);
    }
    return (
        <>
            <Dialog
                open={open}
                onClose={() => handleCloseCreateModal()}
                fullWidth
                maxWidth="sm"
            >
                {!view && <DialogTitle sx={{ marginBottom: 0, display: "flex", justifyContent: "space-between", alignItems: 'center' }} id="draggable-dialog-title">
                    <Typography sx={{ fontSize: "1.15em" }}> {!!currentLLMConfigurationData ? "Edit LLM Configuration" : "Create LLM Configuration"}</Typography>
                    <CloseIcon sx={{ cursor: 'pointer' }} onClick={() => handleCloseCreateModal()} />
                </DialogTitle>}
                <form onSubmit={(e) => saveTopic(e)}>
                    <DialogContent>
                        <FormControl fullWidth sx={{ mt: 3, flex: 1 }}>
                            <InputLabel id="llm">
                                Select LLM*
                            </InputLabel>
                            <Select
                                labelId="llm"
                                id="llm-select"
                                value={llmConfigurationData?.llm_name}
                                label="Select LLM*"
                                onChange={(e) => {
                                    setLLMConfigurationData((prev) => ({
                                        ...prev,
                                        llm_name: (e.target.value) as keyof typeof LLMModels,
                                        llm_model_name: ""
                                    }));
                                }}
                            >
                                {LLMOptions?.map((option, index) => {
                                    return (
                                        <MenuItem
                                            key={index}
                                            value={option?.value}
                                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                        >
                                            <img width="20" height="20" src={option?.img} />
                                            {option?.name}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                            {validateError?.includes("llm_name") && <Typography sx={{ color: "#d32f2f", fontSize: "0.64rem", ml: "14px", mt: "3px" }}>Please select LLM.</Typography>}
                        </FormControl>
                        <FormControl fullWidth sx={{ mt: 3, flex: 1 }}>
                            <InputLabel id="llm-model">
                                Select LLM Model*
                            </InputLabel>
                            <Select
                                labelId="llm-model"
                                id="llm-model"
                                value={llmConfigurationData?.llm_model_name}
                                label="Select LLM Model*"
                                onChange={(e) => {
                                    setLLMConfigurationData((prev) => ({
                                        ...prev,
                                        llm_model_name: e.target.value,
                                    }));
                                }}
                            >
                                {llmConfigurationData?.llm_name && LLMModels[llmConfigurationData?.llm_name]?.map((option, index) => {
                                    return (
                                        <MenuItem
                                            key={index}
                                            value={option.value}
                                            sx={{
                                                // maxWidth: "30rem",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                padding: 1.5,
                                                borderBottom: llmConfigurationData?.llm_name && index < LLMModels[llmConfigurationData!.llm_name].length - 1 ? "1px solid #eee" : "none",
                                            }}
                                        >
                                            {option.label}
                                            {/* <Typography fontWeight="medium">{option.label}</Typography>
                                            <Typography variant="caption" color="text.secondary" sx={{
                                                mt: 0.5,
                                                lineHeight: 1.3,
                                                wordBreak: "break-word",
                                                overflowWrap: "break-word",
                                                whiteSpace: "normal",
                                                width: "100%",
                                            }}>
                                                {option.description}
                                            </Typography> */}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                            {validateError?.includes("llm_model_name") && <Typography sx={{ color: "#d32f2f", fontSize: "0.64rem", ml: "14px", mt: "3px" }}>Please select LLM model.</Typography>}
                        </FormControl>
                        <TextField
                            margin="normal"
                            fullWidth
                            id="api_key"
                            label="API Key*"
                            name="api_key"
                            autoComplete="api_key"
                            value={llmConfigurationData?.api_key || ""}
                            onChange={(e) => {
                                setLLMConfigurationData((prev) => ({
                                    ...prev,
                                    api_key: e?.target?.value,
                                }))
                            }}
                            error={validateError.includes("api_key")}
                            helperText={
                                validateError.includes("api_key") &&
                                "Please enter API key"
                            }
                        />

                        <TextField
                            margin="normal"
                            fullWidth
                            id="thread_length"
                            label="Thread Length*"
                            name="thread_length"
                            autoComplete="thread_length"
                            value={llmConfigurationData?.thread_length || ""}
                            onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                    setLLMConfigurationData((prev) => ({
                                        ...prev,
                                        thread_length: e?.target?.value,
                                    }))
                                }
                            }}
                            error={validateError.includes("thread_length")}
                            helperText={
                                validateError.includes("thread_length") &&
                                "Please enter thread length"
                            }
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant='outlined' onClick={() => handleCloseCreateModal()}>
                            Cancel
                        </Button>
                        <LoadingButton type='submit' className={!!currentLLMConfigurationData ? 'ga-update-admin' : 'ga-create-admin'} loading={loader} variant='contained'>
                            {!!currentLLMConfigurationData ? "Update" : "Create"}
                        </LoadingButton>
                    </DialogActions>
                </form>
            </Dialog >
        </>
    )
}

export default CreateEdit;

export const LLMOptions = [
    {
        name: "ChatGPT",
        value: "chatgpt",
        img: chatGptIcon
    },
    {
        name: "Gemini",
        value: "gemini",
        img: geminiIcon
    },
    {
        name: "Anthropic Claude",
        value: "claude",
        img: claudeIcon
    },
]

export const LLMModels = {
    chatgpt: [
        {
            "label": "GPT-4o",
            "value": "gpt-4o",
            "description": "Latest multimodal model (text & image input, text output). Faster and cheaper than GPT-4 Turbo."
        },
        {
            "label": "GPT-4o Mini",
            "value": "gpt-4o-mini",
            "description": "Smaller and efficient version of GPT-4o, optimized for cost and performance."
        },
        {
            "label": "GPT-4 Turbo",
            "value": "gpt-4-turbo",
            "description": "Advanced large-scale model optimized for complex tasks and chat."
        },
        {
            "label": "GPT-3.5 Turbo",
            "value": "gpt-3.5-turbo",
            "description": "Cost-effective and fast model for general tasks."
        }
    ],
    gemini: [
        {
            "label": "Gemini 2.0 Flash",
            "value": "gemini-2.0-flash",
            "description": "A versatile model designed for daily tasks, offering strong overall performance with support for real-time streaming via the Live API."
        },
        {
            "label": "Gemini 2.0 Pro",
            "value": "gemini-2.0-pro-exp-02-05",
            "description": "An advanced model excelling in code and world knowledge tasks, featuring a 2 million token long context window."
        },
        {
            "label": "Gemini 2.0 Flash-Lite",
            "value": "gemini-2.0-flash-lite",
            "description": "A cost-effective model designed for high-throughput applications, balancing performance and efficiency."
        },
        {
            "label": "Gemini 2.0 Flash Thinking",
            "value": "gemini-2.0-flash-thinking-exp-01-21",
            "description": "An experimental model with enhanced reasoning capabilities, incorporating a 'thinking process' in its responses."
        },
        {
            "label": "Gemini 1.5 Flash",
            "value": "gemini-1.5-flash",
            "description": "A model optimized for speed and efficiency, suitable for high-volume, quality, and cost-effective applications."
        },
        {
            "label": "Gemini 1.5 Pro",
            "value": "gemini-1.5-pro",
            "description": "A model supporting text or chat prompts, providing text or code responses, with long-context understanding up to the maximum input token limit."
        },
        {
            "label": "Gemini 1.0 Pro",
            "value": "gemini-1.0-pro",
            "description": "A high-performing model suitable for a wide range of text-only tasks."
        },
        {
            "label": "Gemini 1.0 Pro Vision",
            "value": "gemini-1.0-pro-vision",
            "description": "A model excelling in image and video understanding, capable of handling a broad range of applications."
        }
    ],
    claude: [
        {
            "label": "Claude 3.7 Sonnet",
            "value": "claude-3.7-sonnet",
            "description": "A hybrid reasoning model that balances speed and quality, excelling in complex problem-solving tasks such as coding and mathematics. It offers 'extended thinking' capabilities, allowing users to choose between rapid responses and more deliberate, step-by-step reasoning."
        },
        {
            "label": "Claude 3.5 Haiku",
            "value": "claude-3.5-haiku",
            "description": "A lightweight model optimized for speed and efficiency, suitable for high-volume tasks requiring quick responses."
        },
        {
            "label": "Claude 3 Opus",
            "value": "claude-3-opus",
            "description": "The most capable model in the Claude 3 family, designed for complex reasoning tasks and achieving high performance across various benchmarks."
        },
        {
            "label": "Claude 2.1",
            "value": "claude-2.1",
            "description": "An improved version of Claude 2, featuring a 200,000-token context window and enhanced accuracy, reducing the likelihood of producing false statements."
        },
        {
            "label": "Claude 2",
            "value": "claude-2",
            "description": "A publicly available model that expanded its context window to 100,000 tokens, enabling tasks like summarizing extensive documents and coding assistance."
        },
        {
            "label": "Claude Instant",
            "value": "claude-instant",
            "description": "A faster, less expensive, and lighter version of the original Claude model, suitable for applications requiring quick responses."
        },
        {
            "label": "Claude",
            "value": "claude",
            "description": "The initial version of Anthropic's language model, demonstrating proficiency in various tasks with certain limitations in coding, math, and reasoning capabilities."
        }
    ]
}
